<div class="page-size-container">

  <div class="info">
    Showing {{start}} - {{end}} of {{total}}
  </div>

  <div class="d-flex align-items-center">
    Items Per Page : 
    <ng-select class="ml-2" placeholder="Rows Per Page"
    [items]="pageSizeOptions" clearable="false"
    [(ngModel)]="pageSize"
    (change)="onChange($event)">
    </ng-select>
  </div>

</div>
